import React, { useState } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

// import { useAppSelector } from 'store';
// import { useSendLead } from 'modules/course-detail';
import { globalConst, onTrackYandexGoal } from 'modules/global';

import { SuccessModal } from 'components';

import LeadModal from './lead-modal';
import Price from './price';

interface IProps {
  price?: number;
  discount?: number;
  isFree?: boolean;
  className?: string;
  courseId?: number;
}

const BuyCourse: React.FC<IProps> = ({ discount, isFree, price, className, courseId }) => {
  const t = useTranslations();
  // COMMENTLAR KERAK BO"LADI
  //
  // const { mutate, isLoading } = useSendLead();
  // const isAuth = useAppSelector(({ user }) => user?.phone);
  // const userName = useAppSelector(({ user }) => user?.name);
  // const userPhone = useAppSelector(({ user }) => user?.phone);
  const [successModal, setSuccessModal] = useState(false);
  const [openLeadModal, setOpenLeadModal] = useState(false);

  // const onAfterSuccess = () => {
  //   setSuccessModal(true);
  //   setTimeout(() => {
  //     setSuccessModal(false);
  //   }, 2000);
  // };

  // const sendLead = () => {
  //   if (!isAuth) {
  //     setOpenLeadModal(true);
  //     return;
  //   }

  //   const data = {
  //     name: userName,
  //     phone: userPhone,
  //     teacher_course_id: courseId
  //   };

  //   mutate(data, {
  //     onSuccess: onAfterSuccess
  //   });
  // };

  return (
    <>
      <div className={`space-y-3 rounded-xl bg-purple-100 p-3 sm:bg-white ${className}`}>
        <Price discount={discount} isFree={isFree} price={price} />
        {/* 
        KERAK BO"LADI
        <div className="m-0 flex justify-center gap-2 sm:m-auto">
          <PaymentMethod
            icon={<PaymeIcon className="w-14.5" />}
            method="payme"
            setSelectedPayment={setSelectedPayment}
            selectedPayment={selectedPayment}
          />
          <PaymentMethod
            icon={<ClickAppIcon className="w-14.5" />}
            method="click"
            setSelectedPayment={setSelectedPayment}
            selectedPayment={selectedPayment}
          />
        </div> */}
        <div className="fixed z-11 bottom-0 left-0 right-0 h-20 rounded-t-xl bg-white p-4 sm:static sm:mt-3 sm:h-full sm:bg-transparent sm:p-0">
          <Link
            target="_blank"
            href={`${process.env.NEXT_PUBLIC_AKAM_ADMIN}`}
            onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.course_lead)}
            className="text-md block !w-full cursor-pointer rounded-lg text-center text-sm border-transparent bg-green-500 py-3 sm:py-2 font-medium text-white hover:bg-green-600"
          >
            {t('ArizaQoldirish')}
          </Link>
        </div>
      </div>

      <LeadModal
        courseId={courseId}
        open={openLeadModal}
        onClose={() => setOpenLeadModal(false)}
        setSuccessVisible={setSuccessModal}
      />
      <SuccessModal open={successModal} onClose={() => setSuccessModal(false)} />
    </>
  );
};

export default BuyCourse;
